<template>
    <div class="planItemTable">
        <div class="planItemTable__item">
            <div class="planItemTable__title">
                {{ $filters.floatNumber(tableData.credits, 'en-US') }}
                plan credits / {{ tableData.period }}
            </div>
            <div class="planItemTable__value">
                ${{ $filters.floatNumber(tableData.price, 'en-US') }}
            </div>
        </div>
        <div class="planItemTable__item">
            <div class="planItemTable__title">
                <span>
                    {{ $filters.floatNumber(tableData.extraCredits, 'en-US') }}
                    overage credits
                </span>
                <a
                    v-tooltip="{
                        popperClass: 'planItemTable__tooltip__content',
                        placement: 'top',
                        content: 'Auto-recharge and/or manually bought credits',
                        boundary: 'viewport',
                    }"
                    class="planItemTable__tooltip"
                >
                    <info-icon />
                </a>
            </div>
            <div class="planItemTable__value">
                ${{ $filters.floatNumber(tableData.extraPrice, 'en-US') }}
            </div>
        </div>
        <div class="planItemTable__item">
            <div class="planItemTable__title planItemTable__title--small">
                ${{ tableData.additionalCredit }} per additional credit
            </div>
            <div
                v-if="tableData.additionalDiscount && tableData.additionalDiscount > 0"
                class="planItemTable__value discount"
            >
                {{ tableData.additionalDiscount }}% off
            </div>
        </div>
    </div>
</template>

<script>
import InfoIcon from './InfoIcon.vue';

export default {
    name: 'PlanItemTable',

    components: {
        InfoIcon,
    },

    props: {
        tableData: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.planItemTable__tooltip__content {
    width: 301px;

    .tooltip-inner {
        color: #fff;
        font-family: Inter;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 123%;
        border-radius: 6px;
        padding: 6px 8px;
        max-width: 100%;
    }
}
</style>

<style lang="scss" scoped>
@import 'styles.module.scss';
</style>
